module.exports = __webpack_public_path__ + "static/Silvia-Gasparini-9e95fcf54c4d6914686f7741161480e5.jpg";